import { Box, Typography, Button, Modal } from "@mui/material";

const DeleteGoalTournamentModal = ({
  state,
  setState,
  handlerFunction,
  message,
  data,
}) => {
  //   const [openDelete, setOpenDelete] = useState(false);
  // const handleTournamentDelete = () => {};
  return (
    <>
      <Modal
        open={state}
        onClose={() => setState(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {message}
          </Typography>
          <Box
            sx={{
              marginTop: "17px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <Button
              variant="outlined"
              sx={{
                borderRadius: "5px !important",
                backgroundColor: "#ef364e !important",
                color: "white !important",
                border: "none",
                "&:hover": {
                  border: "none",
                  opacity: "0.75",
                },
              }}
              onClick={() => {
                handlerFunction(data);
                setState(false);
              }}
            >
              Yes
            </Button>
            <Button
              sx={{
                borderRadius: "5px !important",
                backgroundColor: "#cbc7c7 !important",
                color: "white !important",
                border: "none",
                "&:hover": {
                  border: "none",
                  opacity: "0.75",
                },
              }}
              variant="outlined"
              onClick={() => setState(false)}
            >
              No
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeleteGoalTournamentModal;
